import { render, staticRenderFns } from "./PLogo.vue?vue&type=template&id=29f8ab10&scoped=true"
import script from "./PLogo.vue?vue&type=script&lang=js"
export * from "./PLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f8ab10",
  null
  
)

export default component.exports